import { Configuration } from "@freightsimple/generated-dashboard-openapi-client/runtime";
import { InvitationsApi } from "@freightsimple/generated-dashboard-openapi-client/apis/InvitationsApi";
import { getConfig } from "@/Apis/getConfig";

export function useInvitationsApi(): InvitationsApi {
  return new InvitationsApi(new Configuration({ ...getConfig() }));
}
